module.exports = __webpack_public_path__ + "img/samplering@2x.7d36931.jpg";